<template>
    <div id="actionBar" class="dashed-space">
        <div>
            <i @click="$router.go(-1)" v-if="backButton" class="fas fa-chevron-left"></i>
        </div>
        <div>
            <span id="title" v-if="title">{{ title }}</span>
        </div>
        <div></div>
    </div>
</template>

<script>
export default {
    name: "header",
    props: {
        title: { type: String },
        backButton: { type: Boolean }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#actionBar {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    background-color: #ffffff;
    z-index: 1001;

    div:first-child,
    div:last-child {
        flex: 0.2;
    }

    div {
        flex: 1;
    }

    i {
        color: #4600b6;
    }

    #title {
        font-size: 30px;
        color: #4600b6;
    }
}
</style>
